import { styled } from 'baseui'
import { FlexCenter, FlexBetween } from '@/shared/theme/styled-components'

export const ViewButtonsRow = styled('div', {
  display: 'flex',
  gap: '0.5rem',
  marginBottom: '0.75rem',
  flexWrap: 'wrap',
})

export const SearchActions = styled('div', {
  marginLeft: 'auto',
  display: 'flex',
  gap: '0.25rem',
})

export const TableWrapper = styled('div', {
  position: 'relative',
})

export const LoadingOverlay = styled(FlexCenter, ({ $theme }) => ({
  position: 'absolute',
  inset: 0,
  background: $theme.colors.overlayWhite60,
  backdropFilter: 'blur(2px)',
  pointerEvents: 'none',
}))

export const FooterRow = styled(FlexBetween, {
  marginTop: '0.75rem',
})

export const ResultsCount = styled('div', {
  fontSize: '0.75rem',
})

export const ModalBodyContent = styled('div', {
  '& p:first-child': { marginTop: 0 },
  '& p:last-child': { marginBottom: 0 },
})
